


































































































import Component from "vue-class-component";
import { IDashboardData } from "@/types/Dashboard.model";
import { MyOptions } from "@/charts/graphData";
import DashboardTotalCard from "./DashboardTotalCard.vue";
import DashboardEnseigneCard from "./DashboardEnseigneCard.vue";
import DashboardHistoricalCard from "./DashboardHistoricalCard.vue";
import {Prop} from "vue-property-decorator";
import Vue from "vue";

@Component({
  components: {
    DashboardTotalCard,
    DashboardEnseigneCard,
    DashboardHistoricalCard,
  },
})
export default class DashboardMobileCarousel extends Vue {
  @Prop() public dashboardData!: IDashboardData;
  @Prop() public isTTC!: boolean;
  @Prop() public myOptions!: MyOptions;

  public onRenderFinished() {
    this.$emit("renderFinished");
  }

  public onInit() {
    this.$emit("init");
  }
}
